// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-box {
    margin-left: 15px;
}

.filter-options-box {
    height: fit-content;
    overflow-y: auto;
    max-height: 350px;
    display: grid;
}

.button-filter-options-list {
    width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/TeamAlerts/component/SearchTab/TooltipFilter/FilterBox.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".filter-box {\n    margin-left: 15px;\n}\n\n.filter-options-box {\n    height: fit-content;\n    overflow-y: auto;\n    max-height: 350px;\n    display: grid;\n}\n\n.button-filter-options-list {\n    width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
